<!-- Start Breadcrumbs -->
<app-breadcrumbs title="Inventory" [breadcrumbItems]="breadCrumbItems"></app-breadcrumbs>
<!-- End Breadcrumbs -->

<div class="row">
  <div class="col-lg-12">
    <div class="card">
      <!-- Header -->
      <div class="card-header border-0">
        <div class="row align-items-center gy-3">
          <div class="col-sm">
            <h5 class="card-title mb-0">Inventory Management</h5>
          </div>
          <div class="col-sm-auto">
            <div class="d-flex gap-1 flex-wrap">
              <button type="button" class="btn btn-info" (click)="refreshData()">
                <i class="ri-refresh-line align-bottom me-1"></i> Refresh
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Filters -->
      <div class="card-body border border-dashed border-end-0 border-start-0">
        <div class="row g-3">
          <!-- <div class="col-xxl-5 col-sm-6">
            <div class="search-box">
              <input type="text" name="searchTerm" class="form-control" placeholder="Search by item name or code..." 
                     [(ngModel)]="searchTerm" [ngModelOptions]="{standalone: true}" 
                     (keyup.enter)="performSearch()" (blur)="performSearch()">
              <i class="ri-search-line search-icon"></i>
            </div>
          </div> -->
          
          <div class="col-xxl-3 col-sm-4">
            <select class="form-control" name="categoryFilter" [(ngModel)]="categoryFilter" 
                    [ngModelOptions]="{standalone: true}" (ngModelChange)="filterByCategory()">
              <option value="">All Categories</option>
              <option *ngFor="let category of categories" [value]="category.id">
                {{ category.name }}
              </option>
            </select>
          </div>

          <!-- <div class="col-xxl-2 col-sm-2">
            <select class="form-control" name="isActiveFilter" [(ngModel)]="isActiveFilter" 
                    [ngModelOptions]="{standalone: true}" (ngModelChange)="filterByStatus()">
              <option [ngValue]="true">Active</option>
              <option [ngValue]="false">Inactive</option>
            </select>
          </div> -->
        </div>
      </div>

      <!-- Table -->
      <div class="card-body pt-0">
        <div *ngIf="isLoading" class="text-center py-5">
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>

        <div *ngIf="!isLoading" class="table-responsive table-card mb-0">
          <table class="table align-middle table-nowrap">
            <thead class="table-light">
              <tr>
                <th>Item Code</th>
                <th>Item Name</th>
                <th>Category</th>
                <th>Unit</th>
                <th>Current Stock</th>
                <th>Ordered Qty</th>
                <th>Pending Order Qty</th>
                <th>Pending QC</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngIf="inventoryItems.length === 0">
                <td colspan="8" class="text-center py-4">
                  <div class="text-muted">
                    <i class="ri-inbox-line fs-1"></i>
                    <p class="mt-2">No inventory items found</p>
                  </div>
                </td>
              </tr>
              
              <tr *ngFor="let item of inventoryItems; let i = index">
                <td>
                  <strong class="text-primary">{{ item.code }}</strong>
                </td>
                <td>
                  <div class="d-flex align-items-center">
                    <div>
                      <h6 class="mb-0">{{ item.name }}</h6>
                    </div>
                  </div>
                </td>
                <td>
                  <span class="badge bg-secondary-subtle text-secondary">
                    {{ item.category?.name}}
                  </span>
                </td>
                <td>
                  <span class="badge bg-light text-dark">
                    {{ item.unit?.symbol || item.unit?.name }}
                  </span>
                </td>
                <td>
                  <div class="d-flex align-items-center">
                    <strong class="fs-5" [ngClass]="getStockStatusClass(item.current_stock, item.ordered_quantity)">
                      {{ item.current_stock }}
                    </strong>
                    <span class="ms-1 text-muted">{{ item.unit?.symbol || '' }}</span>
                  </div>
                </td>
                <td>
                  <div class="d-flex align-items-center">
                    <span class="badge" [ngClass]="{
                      'bg-info-subtle text-info': item.ordered_quantity > 0,
                      'bg-secondary-subtle text-secondary': item.ordered_quantity === 0
                    }">
                      {{ item.ordered_quantity || 0 }}
                    </span>
                  </div>
                </td>
                <td>
                  <div class="d-flex align-items-center">
                    <span class="badge" [ngClass]="{
                      'bg-info-subtle text-info': item.pending_receive_quantity > 0,
                      'bg-secondary-subtle text-secondary': item.pending_receive_quantity === 0
                    }">
                      {{ item.pending_receive_quantity || 0 }}
                    </span>
                  </div>
                </td>
                <td>
                  <div class="d-flex align-items-center">
                    <span class="badge" [ngClass]="{
                      'bg-warning-subtle text-warning': item.pending_qc_quantity > 0,
                      'bg-secondary-subtle text-secondary': item.pending_qc_quantity === 0
                    }">
                      {{ item.pending_qc_quantity || 0 }}
                    </span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Pagination -->
        <div class="row justify-content-md-between align-items-md-center mt-3" *ngIf="inventoryItems.length > 0">
          <div class="col col-sm-6">
            <div class="dataTables_info mb-2">
              Showing {{ ((currentPage - 1) * perPage) + 1 }} to {{ Math.min(currentPage * perPage, total) }} of {{ total }} entries
            </div>
          </div>
          <div class="col col-sm-6">
            <div class="text-sm-end float-end listjs-pagination">
              <ngb-pagination 
                [collectionSize]="total" 
                [(page)]="currentPage" 
                [pageSize]="perPage" 
                (pageChange)="changePage($event)"
                [maxSize]="5"
                [rotate]="true"
                [boundaryLinks]="true">
              </ngb-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


